import { useMutation } from '@tanstack/react-query';

import { useSupabase } from './use-supabase';

export function useSignInWithPasskey() {
  const client = useSupabase();
  const mutationKey = ['auth', 'sign-in-with-passkey'];

  const mutationFn = async () => {
    const response = await client.auth.signInWithPasskey();

    if (response.error) {
      throw response.error;
    }

    return response.data;
  };

  return useMutation({ mutationKey, mutationFn });
}
